import { render, staticRenderFns } from "./XlsDownload.vue?vue&type=template&id=dec0c0f6"
import script from "./XlsDownload.vue?vue&type=script&lang=js"
export * from "./XlsDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../shieldgo-admin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports